import { QueryClient } from '@tanstack/react-query';

/*
 * QueryClient-instanssi koko sovellukselle.
 *
 * Kytkokset:
 * - main.tsx kaarii RouterProviderin QueryClientProviderilla, joka antaa taman
 *   instanssin koko sovelluksen kaytettavaksi.
 * - Komponentit kayttavat useQuery / useMutation -hookkeja, jotka kutsuvat
 *   alla olevia oletuksia ellei kutsukohdassa erikseen ohiteta.
 *
 * Oletukset (kalibroidaan kayton kasvaessa):
 * - staleTime 5 min: tietoa pidetaan tuoreena 5 min ennen automaattista
 *   refetchia. Sopiva markkinointityokalulle, jossa data ei paivity sekuntien
 *   tahdissa.
 * - gcTime 30 min: kayttamattomat cache-merkinnat poistetaan muistista 30 min
 *   jalkeen. Riittavan pitka jotta navigointi edestakaisin on instantia, mutta
 *   ei pida turhaan viittauksia hengissa.
 * - retry: 1 yritys queryille (yleensa GET, idempotentti). Mutaatioissa ei
 *   automaattista retrya, koska duplikaatti POST voi luoda kaksoisrivin.
 * - refetchOnWindowFocus: false. Ikkunaan palaaminen on yleensa kohinaa
 *   markkinointityokalussa, ei reaaliaikajarjestelma. Voidaan kytkea kohdittain.
 *
 * Auth-401-kasittely tehdaan apiFetchin tasolla (lib/api.ts), ei TanStack Queryn
 * tasolla. Nain sama logiikka kattaa myos suorat apiFetch-kutsut (esim.
 * imperatiiviset toiminnot kuten "lataa CSV").
 */

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
